import React, { useState, useEffect } from 'react'
import { Link ,useLocation} from 'react-router-dom';
import '../styles/Navbar.css';
const Navbar = () => {
    const [expandNavbar, setExpandNavbar] = React.useState(false);
    const location = useLocation();

    useEffect(() => {
    setExpandNavbar(false);
},[location])


    return (
      <div className="navbar" id={expandNavbar ? "open":"close"}>
          <div className="toggleBtn">
          <button style={{backgroundColor:'gray',color:'black',borderRadius:'5px',height:'50px',width:'80px',fontSize:'20px',position:'relative',left:"280px",top:'5px'}}
          onClick={() => {
            setExpandNavbar((prev) => !prev);
          }}
        >
        Toggle  
        </button>
          </div>
          <div className="links">
              <Link to="/">Home</Link> 
              <Link to="/projects">Projects</Link>
              <Link to='/experience'>Experience</Link>
          </div>
    </div>
  )
}

export default Navbar;